var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ApiClient, ApiUtils, ErrorUtils, NotificationUtils } from "@yodlee/common-components/dist/utilities";
import amplitude from "amplitude-js";
import Axios from "axios";
import fileDownload from 'js-file-download';
import qs from "qs";
import { UrlConfigs } from "../configurations";
var errorHandler = function (error, isUpdate) {
    var _a, _b, _c, _d;
    if (!(((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500 || (isUpdate && ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 400)))
        return;
    try {
        ErrorUtils.showErrorModal((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message);
    }
    catch (err) {
        console.error(err);
    }
};
export var onload = function (authentication) { return ({
    get: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = false; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.ONLOAD), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication),
                paramsSerializer: function (params) { return qs.stringify(params, { arrayFormat: "repeat" }); }
            }).then(function (response) {
                if (response.data.user) {
                    amplitude.init(response.data.amplitudeId, response.data.user.userName, {
                        includeReferrer: true
                    }, function () {
                        amplitude.getInstance().setUserProperties({
                            cobrand: { id: response.data.financialInstitution.id, name: response.data.financialInstitution.name },
                            user: response.data.user,
                        });
                        resolve(response.data);
                    });
                }
                else {
                    resolve(response.data);
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    }
}); };
export var brandLabel = function (authentication) { return ({
    get: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.BRAND_LABEL), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication),
                paramsSerializer: function (params) { return qs.stringify(params, { arrayFormat: "repeat" }); }
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
}); };
export var permission = function (authentication) { return ({
    getAll: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.PERMISSION), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    get: function (userId, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = false; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.USER_PERMISSION(userId)), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
}); };
export var user = function (authentication) { return ({
    getAll: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.USER), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication),
                paramsSerializer: function (params) { return qs.stringify(params, { arrayFormat: "repeat" }); }
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getTemplate: function (isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.USER_TEMPLATE), {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication),
                responseType: "blob"
            }).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    create: function (user, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.post("".concat(UrlConfigs.API_URLS.USER), user, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    createMany: function (userData, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.post("".concat(UrlConfigs.API_URLS.BULK_USER), userData, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    update: function (userId, user, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.patch("".concat(UrlConfigs.API_URLS.USER, "/").concat(userId), user, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    updateMany: function (users, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.patch("".concat(UrlConfigs.API_URLS.BULK_USER), users, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
}); };
export var group = function (authentication) { return ({
    getAll: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.GROUP), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    get: function (groupId, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.GROUP, "/").concat(groupId), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    create: function (group, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.post("".concat(UrlConfigs.API_URLS.GROUP), group, {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    delete: function (groupId, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.delete("".concat(UrlConfigs.API_URLS.GROUP, "/").concat(groupId), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    update: function (groupId, group, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.put("".concat(UrlConfigs.API_URLS.GROUP, "/").concat(groupId), group, {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
}); };
export var role = function (authentication) { return ({
    getAll: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.ROLE), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }, true).then(function (response) {
                resolve(response.data.data);
            }).catch(function (error) {
                var _a;
                if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
                    resolve([]);
                }
                else {
                    errorHandler(error);
                    reject(error);
                }
            });
        });
    },
    get: function (roleId, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.ROLE, "/").concat(roleId), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    create: function (role, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.post("".concat(UrlConfigs.API_URLS.ROLE), role, {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    delete: function (roleId, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.delete("".concat(UrlConfigs.API_URLS.ROLE, "/").concat(roleId), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    update: function (roleId, role, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.post("".concat(UrlConfigs.API_URLS.ROLE, "/").concat(roleId), role, {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    rename: function (role, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.put("".concat(UrlConfigs.API_URLS.ROLE), role, {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
}); };
export var settings = function (authentication) { return ({
    get: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.SETTING), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    update: function (settings, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            Axios.patch("".concat(UrlConfigs.API_URLS.SETTING), settings, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
}); };
export var featuresList = function (authentication) { return ({
    getAllCustomers: function (isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = false; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.SETTING, "/all-customers"), {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    updateCustomer: function (customers, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = false; }
        return new Promise(function (resolve, reject) {
            Axios.post("".concat(UrlConfigs.API_URLS.SETTING, "/all-customers"), customers, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    export: function (attachmentName, filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = false; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.SETTING, "/all-customers/export"), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), (filters || {})),
                headers: ApiUtils.getAuthorizationHeader(authentication),
                responseType: "blob"
            }, true).then(function (response) {
                fileDownload(response.data, attachmentName);
                resolve(response);
            }).catch(function (error) {
                try {
                    if (error.response.status === 500)
                        ErrorUtils.showErrorModal((error.response.data.message || 'Sorry') + ', Export Failed');
                }
                catch (error) {
                    console.error(error);
                }
                reject(error);
            });
        });
    }
}); };
export var logo = function (authentication) { return ({
    get: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.LOGO), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication),
                responseType: "blob"
            }).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    update: function (data, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.post("".concat(UrlConfigs.API_URLS.LOGO), data, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }, true).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                errorHandler(error, true);
                reject(error);
            });
        });
    },
    remove: function (isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.delete("".concat(UrlConfigs.API_URLS.LOGO), {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }, true).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                errorHandler(error, true);
                reject(error);
            });
        });
    },
}); };
export var banner = function (authentication) { return ({
    get: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.BANNER), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication),
                responseType: "blob"
            }).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    update: function (data, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.post("".concat(UrlConfigs.API_URLS.BANNER), data, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    remove: function (isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.delete("".concat(UrlConfigs.API_URLS.BANNER), {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
}); };
export var preference = function (authentication) { return ({
    get: function () { return new Promise(function (resolve, reject) {
        ApiClient.get("".concat(UrlConfigs.API_URLS.PREFERENCE), {
            withCredentials: true,
            params: {
                appId: process.env.REACT_APP_APPLICATION_ID || 'orbit'
            },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then(function (response) {
            resolve(response.data);
        }).catch(function (error) {
            reject(error);
        });
    }); },
    put: function (preference) { return new Promise(function (resolve, reject) {
        ApiClient.put("".concat(UrlConfigs.API_URLS.PREFERENCE), { preference: JSON.stringify(preference || {}) }, {
            withCredentials: true,
            params: {
                appId: process.env.REACT_APP_APPLICATION_ID || 'orbit'
            },
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then(function (response) {
            resolve(response);
        }).catch(function (error) {
            reject(error);
        });
    }); },
}); };
export var cobrandPermission = function (authentication) { return ({
    get: function (filters, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = false; }
        return new Promise(function (resolve, reject) {
            ApiClient.get("".concat(UrlConfigs.API_URLS.COBRAND), {
                withCredentials: true,
                params: __assign(__assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }), filters),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response.data.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    update: function (brandId, data, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            ApiClient.post("".concat(UrlConfigs.API_URLS.COBRAND_PERMISSION(brandId)), data, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    updateBulk: function (data, isBrandSpecific) {
        if (isBrandSpecific === void 0) { isBrandSpecific = true; }
        return new Promise(function (resolve, reject) {
            Axios.patch("".concat(UrlConfigs.API_URLS.COBRAND_PERMISSION_BULK), data, {
                withCredentials: true,
                params: __assign({}, isBrandSpecific && { brandId: authentication.selectedBrand.id }),
                headers: ApiUtils.getAuthorizationHeader(authentication)
            }).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
}); };
export var insightsUsers = function (authentication) { return ({
    get: function (filters) { return new Promise(function (resolve, reject) {
        ApiClient.get("".concat(UrlConfigs.API_URLS.INSIGHT_USERS), {
            withCredentials: true,
            params: __assign({}, filters),
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then(function (response) {
            resolve(response.data);
        }).catch(function (error) {
            reject(error);
        });
    }); },
    create: function (payload) { return new Promise(function (resolve, reject) {
        ApiClient.post("".concat(UrlConfigs.API_URLS.INSIGHT_USERS), payload, {
            withCredentials: true,
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then(function (response) {
            resolve(response.data);
        }).catch(function (error) {
            var _a;
            try {
                if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                    ErrorUtils.showErrorModal(error.response.data.message);
                }
                else if (error.response.status === 400) {
                    NotificationUtils.warning("Update failed.", error.response.data.message || "Something went wrong.", "ghost");
                }
            }
            catch (error) {
                console.error(error);
            }
            reject(error);
        });
    }); },
    delete: function (filters) { return new Promise(function (resolve, reject) {
        ApiClient.delete("".concat(UrlConfigs.API_URLS.INSIGHT_USERS), {
            withCredentials: true,
            params: __assign({}, filters),
            headers: ApiUtils.getAuthorizationHeader(authentication),
        }).then(function (response) {
            resolve(response.data);
        }).catch(function (error) {
            reject(error);
        });
    }); }
}); };
//# sourceMappingURL=data.js.map